export default {
	ninzhidexinlande: '您值得信賴的旅行夥伴',
	zainalizhaodaonixiangyao: '在哪裡找到你想要的廉價班機？',
	zhaodaoyitiaoshihenideluxian: '找到一條適合你的路線',
	zuijindedijiajipiao: '最近的低價機票',
	qingshuruhuoxuanzenidechengshi: '請輸入或選擇您的目的地',
	wodeyuding: '我的預訂',
	kehuzhiyuan: '客戶支援',
	denglu: '登錄',
	yingwen: '英文',
	suoyouhangban: '所有機場',
	gangbi: '港幣',
	baokuoshuifei: '包括稅費',
	baokuotuoyunxingli: '包括託運行李',
	zhongzhuan: '中轉',
	shijian: '次',
	yuyan: '語言',
	bizhong: '幣種',
	jipiao: '機票',
	xuesheng: '學生機票',
	guyong: '僱傭',
	haiyuan: '海員',
	lvxingtuan: '旅行團',
	zuche: '租車服務',
	laihui: '往返',
	dancheng: '單程',
	duogemudidi: '多個目的地',
	you: '出發',
	dao: '到達',
	chufashijian: '出發時間',
	fanchengshijian: '返程時間',
	lvke: '旅客',
	cangdeng: '艙等',
	jingjicang: '經濟艙',
	toudengcang: '头等艙',
	shangwucang: '商务艙',
	gaojijingjicang: '高級經濟艙',
	souxun: '搜尋',
	nianling: '年齡',
	sui: '歲',
	remenyouhui: '熱門優惠',
	remenjingdian: '熱門景點',
	chengren: '成人',
	xiaotong: '兒童',
	yinger: '嬰兒',
	souxunhangban: '搜尋航班',
	liaojiegengduo: '了解更多',
	guanyu: '關於',
	guanyuwomen: '關於我們',
	lianluowomen: '聯絡我們',
	fukuan: '付款',
	tiaokuanyuxize: '條款與細則',
	yinsizhengce: '私隱政策',
	fuwu: '服務',
	hangban: '航班',
	jiudian: '酒店',
	xueshengjipiao: '學生機票',
	guyongjipiao: '僱傭機票',
	haiyuanjipiao: '海員機票',
	changjianwenti: '常見問題',
	dingyueyoujian: '訂閱電子郵件',
	nideyoujian: '你的電子郵件',
	qingshuru: '請輸入',
	womenjieshou: '我們接受',
	paixushaixuan: '排序和篩選',
	remenhangbanyouhui: '熱門班機優惠',
	chengshi: '城市',
	yaozuodeshiqing: '熱門',
	huodong: '活動',
	ranggoupiaogengrongyi: "Taro-Trip堅持“讓購票更容易”的理念，為用戶提供高品質的線上售票服務，為客戶出行提供便利，為旅遊業和經濟發展做出貢獻。",
	banquansuoyou: '版權所有',
	xiangtongchengshitishi: '出發城市與目的地都市不能是同一個',
};
